import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, NOT_FOUND_PATH } from 'configs/AppConfig'
import useBodyClass from 'hooks/useBodyClass';
import RoleBasedRouting from "auth/gard/RoleBasedRouting";
import { ROLE_SHOP, ROLE_ADMIN, ROLE_SALESMAN, ROLE_MANAGER } from "../redux/constants/Auth";
import ErrorOne from "./errors/error-page-1";
import JwtAuthService from "services/JwtAuthService";
import { useQuery } from "@tanstack/react-query";
import { useThemeSwitcher } from "react-css-theme-switcher";

export const Views = (props) => {
  const { locale, location, direction, currentTheme } = props;
  const currentAppLocale = AppLocale[locale];
  const { switcher, themes } = useThemeSwitcher();
  const [messages, setMessages] = useState(null);
  useBodyClass(`dir-${direction}`);
  useQuery(
    {
      queryKey: ['refresh_token'],
      queryFn: () => {
        JwtAuthService.refreshToken()
      },
      retry: false,
      refetchInterval: 2700000,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
      throwOnError: false,
      notifyOnChangeProps: [],
      enabled: location.pathname.startsWith(APP_PREFIX_PATH),
    }
  );

  useEffect(() => {
    switcher({ theme: themes[currentTheme] });
  }, [currentTheme])

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const currentAppLocale = AppLocale[locale];
        const fetchedMessages = await currentAppLocale.fetchMessages();
        setMessages(fetchedMessages);
      } catch (error) {
        setMessages({});
        console.log('Error loading messages:', error);
      }
    };

    loadMessages();
  }, [locale]);

  if (!messages) {
    return <div>Loading...</div>; // Display a loader while fetching translations
  }
  //JwtAuthService.refreshToken();
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      onError={() => { }}
      messages={messages}>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={AUTH_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <RoleBasedRouting path={APP_PREFIX_PATH} AuthNeeded={[ROLE_SHOP, ROLE_ADMIN, ROLE_SALESMAN, ROLE_MANAGER]}>
            <AppLayout direction={direction} location={location} />
          </RoleBasedRouting>
          <Route path={NOT_FOUND_PATH}>
            <ErrorOne />
          </Route>
          <Redirect to={AUTH_PREFIX_PATH} />
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction, currentTheme } = theme;
  const { token } = auth;
  return { locale, token, direction, currentTheme }
};

export default withRouter(connect(mapStateToProps)(Views));